import {computed, observable, useAsObservableSource, useContext} from '@api'
import {useLocalStore} from 'mobx-react-lite'
import {CatalogStore, ContextMenuStore, CatalogPresetsStore, globalStores, Stores, SyncProgressStore, TagsStore, VLPStore, StoresInstance, WorkspacesStore} from '@stores'
import {DragDropStore} from '@stores/dragDrop'
import {ExportStore} from '@stores/export'
import React, {useEffect} from 'react'

/**
 * Stores that should be separated per <CatalogRoot /> instead of global for the entire application
 */
export interface IVipLocalStores {
  catalog: CatalogStore
  dragDrop: DragDropStore
  export: ExportStore
  contextMenu: ContextMenuStore
  syncProgress: SyncProgressStore
  presets: CatalogPresetsStore
  tags: TagsStore
  vlp: VLPStore
}

/**
 * Creates a new {@see useLocalStore} but passes it the active WorkspaceStores instance for this react render tree
 *
 * {@see IVipLocalStores} {@see VipLocalStore}
 * @param createStore
 */
export function useVipLocalStore<T extends VipLocalStore>(createStore: (stores: StoresInstance) => T) : T {
  const stores = useStores()

  const store = useLocalStore(() => createStore(stores ?? globalStores))

  useEffect(() => {
    if (!store.stores) {
      store.stores = stores
    }
  }, [stores])

  return store
}

export const StoresInstanceContext = React.createContext<StoresInstance>(undefined)
export const useStores = () => {
  const stores = useContext(StoresInstanceContext)
  return stores ?? globalStores
}

export class VipLocalStore {
  constructor(stores: StoresInstance) {
    this.stores = stores
    if (!stores) {
      debugger
      throw Error(`Cannot create VIP Local Store - this component must be underneath a <StoresContext.Provider />`)
    }
  }

  @observable.ref stores : StoresInstance

  get axiosNest() { return this.es.client.axiosNest}
  get strings() { return this.stores.strings}
  get pdf() { return this.stores.pdf}
  get cloudPDF() { return this.stores.cloudPDF}
  get apollo() { return this.stores.apollo}
  get es() { return this.stores.es}

  get queryClient() { return this.stores.queryClient}

  get flexLayout() { return this.stores.flexLayout}

  get site() {
    return this.stores.site
  }

  @computed get workspaces() : WorkspacesStore {
    return this.stores.workspaces ?? globalStores.workspaces
  }

  get catalog() { return this.stores.catalog}

  get filter() { return this.stores.filter}

  get c8() { return this.stores.c8}

  get vlp() { return this.stores.vlp}

  // get library() { return this.stores.library}

  get syncProgress() { return this.stores.syncProgress}

  get groupBy() { return this.stores.groupBy}

  get dragDrop() { return this.stores.dragDrop}

  get contextMenu() { return this.stores.contextMenu}
}



// WEBPACK FOOTER //
// ./src/modules/VipLocalStore.ts